import { render, staticRenderFns } from "./SaberDelProducto.vue?vue&type=template&id=50627cda&scoped=true&"
import script from "./SaberDelProducto.vue?vue&type=script&lang=js&"
export * from "./SaberDelProducto.vue?vue&type=script&lang=js&"
import style0 from "./SaberDelProducto.vue?vue&type=style&index=0&id=50627cda&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50627cda",
  null
  
)

export default component.exports